<header
  class="fixed top-0 left-0 right-0 z-50 thi-landing-header__surface"
  [ngClass]="headerSurfaceClass"
>
  <div class="container mx-auto px-4">
    <div class="flex items-center justify-between h-20">
      <a routerLink="/home" class="flex min-w-0 shrink items-center gap-2 md:shrink-0">
        <img
          src="assets/landing-thi/logo.png"
          alt="THI Invoices"
          width="79"
          height="35"
          decoding="async"
          class="h-10 max-[380px]:h-8 w-auto max-w-[min(140px,42vw)] object-contain"
        />
      </a>

      <!-- Do not use Tailwind "hidden" — global H5BP .hidden { display:none !important } breaks lg:flex -->
      <nav class="thi-header__nav-desk items-center gap-1" aria-label="Main">
        <a
          routerLink="/home"
          routerLinkActive="thi-header__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="thi-header__link px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-200"
        >
          {{ t.nav.home }}
        </a>
        <a
          routerLink="/pricing"
          routerLinkActive="thi-header__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="thi-header__link px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-200"
        >
          {{ t.nav.pricing }}
        </a>
        <a
          routerLink="/articles"
          routerLinkActive="thi-header__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="thi-header__link px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-200"
        >
          {{ t.nav.resources }}
        </a>
        <a
          routerLink="/support"
          routerLinkActive="thi-header__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="thi-header__link px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-200"
        >
          {{ t.nav.contact }}
        </a>
        <a
          routerLink="/about"
          routerLinkActive="thi-header__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="thi-header__link px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-200"
        >
          {{ t.nav.about }}
        </a>
      </nav>

      <div class="flex items-center justify-end gap-1.5 sm:gap-3 shrink-0">
        <!-- Login / account: always visible below md (hamburger menu) — no extra tap -->
        <div class="thi-header__auth-mobile items-center shrink-0">
          <ng-container *ngIf="!loggedIn; else mobileBarLoggedIn">
            <a
              routerLink="/login"
              class="thi-header__auth-mobile-link thi-btn-ghost font-semibold text-sm px-2 py-2 whitespace-nowrap"
            >
              {{ t.nav.login }}
            </a>
          </ng-container>
          <ng-template #mobileBarLoggedIn>
            <a
              [routerLink]="accountDashboardLink"
              class="thi-header__auth-mobile-link thi-btn-ghost font-semibold text-sm px-2 py-2 whitespace-nowrap max-w-[38vw] truncate inline-block"
              [title]="t.nav.myAccount"
            >
              {{ t.nav.myAccount }}
            </a>
          </ng-template>
        </div>

        <div class="relative">
          <button
            type="button"
            id="thi-lang-trigger"
            [attr.aria-expanded]="showLangMenu"
            aria-haspopup="listbox"
            aria-controls="thi-lang-listbox"
            (click)="toggleLangMenu($event)"
            class="thi-lang-trigger inline-flex items-center gap-2 px-3 py-2 text-sm font-semibold rounded-lg text-foreground transition-colors border-0 cursor-pointer hover:text-primary hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            <i class="fa fa-globe w-4 h-4 opacity-80" aria-hidden="true"></i>
            <span class="tabular-nums tracking-wide">{{ lang.toUpperCase() }}</span>
          </button>
          <div
            *ngIf="showLangMenu"
            id="thi-lang-listbox"
            role="listbox"
            [attr.aria-labelledby]="'thi-lang-trigger'"
            (click)="$event.stopPropagation()"
            class="absolute top-full mt-2 bg-card rounded-xl shadow-xl border border-border overflow-hidden z-50 min-w-[100px]"
            [class.end-0]="dir !== 'rtl'"
            [class.start-0]="dir === 'rtl'"
          >
            <button
              type="button"
              role="option"
              *ngFor="let l of languages"
              [attr.aria-selected]="lang === l.code"
              (click)="changeLang(l.code)"
              class="thi-lang-option flex w-full items-center px-4 py-3 text-start text-sm font-medium transition-colors"
              [ngClass]="
                lang === l.code
                  ? 'bg-primary text-primary-foreground'
                  : 'text-foreground/80 hover:bg-secondary'
              "
            >
              {{ l.label }}
            </button>
          </div>
        </div>

        <div class="thi-header__auth-desk items-center gap-2">
          <ng-container *ngIf="!loggedIn; else deskLoggedIn">
            <a routerLink="/login" class="thi-btn-ghost font-semibold">{{ t.nav.login }}</a>
            <a routerLink="/register" class="thi-btn-default shadow-md">{{ t.nav.startFree }}</a>
          </ng-container>
          <ng-template #deskLoggedIn>
            <a [routerLink]="accountDashboardLink" class="thi-btn-ghost font-semibold">{{ t.nav.myAccount }}</a>
          </ng-template>
        </div>

        <button
          type="button"
          (click)="isMenuOpen = !isMenuOpen"
          class="lg:hidden p-2 rounded-lg text-foreground hover:bg-muted"
        >
          <i class="fa" [class.fa-bars]="!isMenuOpen" [class.fa-times]="isMenuOpen"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isMenuOpen" class="lg:hidden bg-card border-t border-border">
    <nav class="container mx-auto px-4 py-6 flex flex-col gap-2" aria-label="Main mobile">
      <a
        routerLink="/home"
        (click)="isMenuOpen = false"
        routerLinkActive="thi-header__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="thi-header__link px-4 py-3 text-base font-semibold rounded-lg transition-colors"
      >
        {{ t.nav.home }}
      </a>
      <a
        routerLink="/pricing"
        (click)="isMenuOpen = false"
        routerLinkActive="thi-header__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="thi-header__link px-4 py-3 text-base font-semibold rounded-lg transition-colors"
      >
        {{ t.nav.pricing }}
      </a>
      <a
        routerLink="/articles"
        (click)="isMenuOpen = false"
        routerLinkActive="thi-header__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="thi-header__link px-4 py-3 text-base font-semibold rounded-lg transition-colors"
      >
        {{ t.nav.resources }}
      </a>
      <a
        routerLink="/support"
        (click)="isMenuOpen = false"
        routerLinkActive="thi-header__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="thi-header__link px-4 py-3 text-base font-semibold rounded-lg transition-colors"
      >
        {{ t.nav.contact }}
      </a>
      <a
        routerLink="/about"
        (click)="isMenuOpen = false"
        routerLinkActive="thi-header__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="thi-header__link px-4 py-3 text-base font-semibold rounded-lg transition-colors"
      >
        {{ t.nav.about }}
      </a>
      <div *ngIf="!loggedIn" class="flex flex-col gap-2 mt-4 pt-4 border-t border-border">
        <a routerLink="/register" (click)="isMenuOpen = false" class="thi-btn-default w-full justify-center inline-flex shadow-md">
          {{ t.nav.startFree }}
        </a>
      </div>
    </nav>
  </div>
</header>
